export const Logo = ({ size = 40, variant = "dark" }) => {
    // "dark" = on light bg (shows dark-teal mark), "light" = on dark bg (shows lime mark)
    const src = variant === "dark" ? "/logos/mark-dark-256.png" : "/logos/mark-lime-256.png";
    return (
        <img
            src={src}
            alt="Scintilla Hub"
            width={size}
            height={size}
            style={{ width: size, height: size, objectFit: "contain" }}
            data-testid="logo-mark"
        />
    );
};

export const LogoWordmark = ({ variant = "dark" }) => {
    const primary = variant === "dark" ? "text-[#0C4650]" : "text-white";
    const accent = "text-[#C7FF2C]";
    return (
        <div className="flex items-center gap-3" data-testid="logo-wordmark">
            <Logo size={40} variant={variant} />
            <div className="leading-none">
                <div className={`font-extrabold text-lg ${primary}`}>
                    Scintilla<span className={accent}>.</span>Hub
                </div>
                <div
                    className={`text-[9px] tracking-[0.25em] font-semibold mt-1 ${variant === "dark" ? "text-[#898A8D]" : "text-[#91C6C0]"}`}
                >
                    ACCENDIAMO CONNESSIONI
                </div>
            </div>
        </div>
    );
};
